import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react'

const ProtectedRoute = ({
	isSession,
	children,
}: {
	isSession: boolean
	children: ReactNode
}) => {
	return isSession ? children : <Navigate to='/login' />
}

export default ProtectedRoute
